export const cleanAddress = value => {
  if (value === "" || value === null || value === undefined) {
    return value;
  }

  const wordToReplace = [
    "City",
    "Distrito",
    "Provincia",
    "Province",
    "District",
    "Region",
    "Municipal",
    "County",
    "Special Administrative Region"
  ];
  const regexPattern = new RegExp(`\\b(${wordToReplace.join("|")})\\b`, "gi");
  const result = value.replace(regexPattern, "");
  return result.trim();
};
